module.exports = __webpack_public_path__ + "static/media/open-menu.1e7ed803.svg";